import { requireNativeView } from 'expo';
import { Platform } from 'react-native';
let ExpoAppleAuthenticationButton;
if (Platform.OS === 'ios') {
    ExpoAppleAuthenticationButton = requireNativeView('ExpoAppleAuthentication');
}
export default ExpoAppleAuthenticationButton;

//# sourceMappingURL=ExpoAppleAuthenticationButton.js.map
